module.exports = __webpack_public_path__ + "img/stylized_fantasy_sword.35c37c63.png";